import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing
const DashBoard = Loadable(lazy(() => import('views/dashboard')));

// Settings Users
const SettingUserView = Loadable(lazy(() => import('views/administrator/SettingUserView')));

// New Users SuperAdmin
const NewUserView = Loadable(lazy(() => import('views/administrator/NewUserView')));

// New Users SuperAdmin
const ListUserView = Loadable(lazy(() => import('views/administrator/ListUserView')));

// New Company Admin
const NewCompanyView = Loadable(lazy(() => import('views/admin/newCompanyView')));

// List Company Admin
const ListCompanyView = Loadable(lazy(() => import('views/admin/ListCompanyView')));

// New User Countable System
const NewUserViewCountable = Loadable(lazy(() => import('views/user/NewUserViewCountable')));

// List Countable System
const ListUserViewCountable = Loadable(lazy(() => import('views/user/ListUserViewCountable')));

// New Permission System
const NewPermissionView = Loadable(lazy(() => import('views/user/NewPermissionView')));

// List Permission System
const ListPermissionView = Loadable(lazy(() => import('views/user/ListPermissionView')));

// Edit Permission System
const EditPermissionView = Loadable(lazy(() => import('views/user/EditPermissionView')));

// Log System
const LogSystemView = Loadable(lazy(() => import('views/Logs/LogSystemView')));

// Edit Profile All Kind of Users
const EditProfileView = Loadable(lazy(() => import('views/common/Users/EditProfileView')));

// Version history
const DetalleVersionView = Loadable(lazy(() => import('views/common/DetalleVersionView')));

// New Type Company Administrator
const NewTypeCompanyView = Loadable(lazy(() => import('views/administrator/NewTypeCompanyView')));

// List Type Companies
const ListTypeCompanyView = Loadable(lazy(() => import('views/administrator/ListTypeCompanyView')));

// New Estados Financieros Administrator
const NewEstadosFinancierosView = Loadable(lazy(() => import('views/administrator/NewEstadosFinancierosView')));

// List Estados Financieros Administrator
const ListEstadosFinancierosView = Loadable(lazy(() => import('views/administrator/ListEstadosFinancierosView')));

// Versions SuperAdmin
const ListVersionsView = Loadable(lazy(() => import('views/administrator/ListVersionsView')));
const NewVersionView = Loadable(lazy(() => import('views/administrator/NewVersionView')));
const LogVersionView = Loadable(lazy(() => import('views/administrator/LogVersionView')));

// Reportes Generales SuperAdmin
const ListReportesGeneralesAdminView = Loadable(lazy(() => import('views/administrator/ListReportesGeneralesAdminView')));
const NewReporteGeneralAdminView = Loadable(lazy(() => import('views/administrator/NewReporteGeneralAdminView')));

// Reportes Administración por Company
const ListReportesAdministracionView = Loadable(lazy(() => import('views/user/ReportesAdministracionView/ListReportesAdministracionView')));
const EditReporteAdministracionView = Loadable(lazy(() => import('views/user/ReportesAdministracionView/EditReporteAdministracionView')));

// List Account Administrator
// New Account Class 1 Administrator
const NewAccountClass1 = Loadable(lazy(() => import('views/administrator/AccountsView/AccountClass1/NewAccountView')));

// List Account Class1 Administrator
const ListAccountViewClass1 = Loadable(lazy(() => import('views/administrator/AccountsView/AccountClass1/ListAccountView')));

// New Account Class 2 Administrator
const NewAccountClass2 = Loadable(lazy(() => import('views/administrator/AccountsView/AccountClass2/NewAccountView')));

// List Account Class2 Administrator
const ListAccountViewClass2 = Loadable(lazy(() => import('views/administrator/AccountsView/AccountClass2/ListAccountView')));

// New Account Class 3 Administrator
const NewAccountClass3 = Loadable(lazy(() => import('views/administrator/AccountsView/AccountClass3/NewAccountView')));

// List Account Class3 Administrator
const ListAccountViewClass3 = Loadable(lazy(() => import('views/administrator/AccountsView/AccountClass3/ListAccountView')));

// New Account Class 4 Administrator
const NewAccountClass4 = Loadable(lazy(() => import('views/administrator/AccountsView/AccountClass4/NewAccountView')));

// List Account Class4 Administrator
const ListAccountViewClass4 = Loadable(lazy(() => import('views/administrator/AccountsView/AccountClass4/ListAccountView')));

// New Account Class 5 Administrator
const NewAccountClass5 = Loadable(lazy(() => import('views/administrator/AccountsView/AccountClass5/NewAccountView')));

// List Account Class5 Administrator
const ListAccountViewClass5 = Loadable(lazy(() => import('views/administrator/AccountsView/AccountClass5/ListAccountView')));

// New Account Class 1 Normal User
const NewAccountClass1User = Loadable(lazy(() => import('views/user/AccountsView/AccountClass1/NewAccountView')));

// List Account Class1 Normal User
const ListAccountViewClass1User = Loadable(lazy(() => import('views/user/AccountsView/AccountClass1/ListAccountView')));

// New Account Class 2 Normal User
const NewAccountClass2User = Loadable(lazy(() => import('views/user/AccountsView/AccountClass2/NewAccountView')));

// List Account Class1 Normal User
const ListAccountViewClass2User = Loadable(lazy(() => import('views/user/AccountsView/AccountClass2/ListAccountView')));

// New Account Class 3 Normal User
const NewAccountClass3User = Loadable(lazy(() => import('views/user/AccountsView/AccountClass3/NewAccountView')));

// List Account Class3 Normal User
const ListAccountViewClass3User = Loadable(lazy(() => import('views/user/AccountsView/AccountClass3/ListAccountView')));

// New Account Class 4 Normal User
const NewAccountClass4User = Loadable(lazy(() => import('views/user/AccountsView/AccountClass4/NewAccountView')));

// List Account Class4 Normal User
const ListAccountViewClass4User = Loadable(lazy(() => import('views/user/AccountsView/AccountClass4/ListAccountView')));

// New Account Class 5 Normal User
const NewAccountClass5User = Loadable(lazy(() => import('views/user/AccountsView/AccountClass5/NewAccountView')));

// List Account Class5 Normal User
const ListAccountViewClass5User = Loadable(lazy(() => import('views/user/AccountsView/AccountClass5/ListAccountView')));

// Wizard Company Settings First Time
const WizardSettingCompanyView = Loadable(lazy(() => import('views/user/WizardSettingCompanyView')));

// Edit Company information
const EditCompanyView = Loadable(lazy(() => import('views/user/CompanyView/EditCompanyView')));

// List All Plan Account Normal User
const ListAllAccountView = Loadable(lazy(() => import('views/user/AccountsView/ListAllAccountView')));

// New Line Normal User
const NewLineUser = Loadable(lazy(() => import('views/user/ProductsView/NewLineView')));

// List Line Normal User
const ListLineUser = Loadable(lazy(() => import('views/user/ProductsView/ListLineView')));

// New Category Normal User
const NewCategoryUser = Loadable(lazy(() => import('views/user/ProductsView/NewCategoryView')));

// List Category Normal User
const ListCategoryUser = Loadable(lazy(() => import('views/user/ProductsView/ListCategoryView')));

// New Subcategory Normal User
const NewSubcategoryUser = Loadable(lazy(() => import('views/user/ProductsView/NewSubcategoryView')));

// List Subcategory Normal User
const ListSubcategoryUser = Loadable(lazy(() => import('views/user/ProductsView/ListSubcategoryView')));

// New Groups Normal User
const NewGroupsUser = Loadable(lazy(() => import('views/user/ProductsView/NewGroupsView')));

// List Groups Normal User
const ListGroupsUser = Loadable(lazy(() => import('views/user/ProductsView/ListGroupsView')));

// New Tipos_iva Normal User
const NewTiposIvaUser = Loadable(lazy(() => import('views/user/Taxes/TiposIvaView')));

// List Tipos Iva Normal User
const ListTiposIvaUser = Loadable(lazy(() => import('views/user/Taxes/ListTiposIvaView')));

// New CodesIce Normal User
const NewCodesIceUser = Loadable(lazy(() => import('views/user/Taxes/NewCodesIceView')));

// List Codes ICE Normal User
const ListCodesIceUser = Loadable(lazy(() => import('views/user/Taxes/ListCodesIceView')));

// New CodigoRetenciones Normal User                                          
const NewCodigoRetencionesUser = Loadable(lazy(() => import('views/user/Taxes/NewCodigoRetencionesView')));

// List Codigo Retenciones Normal User
const ListCodigoRetencionesUser = Loadable(lazy(() => import('views/user/Taxes/ListCodigoRetencionesView')));

// New Products Normal User                                          
const NewProductsUser = Loadable(lazy(() => import('views/user/ProductsView/NewProductsView')));

// List Products Normal User                                          
const ListProductsUser = Loadable(lazy(() => import('views/user/ProductsView/ListProductsView')));

// New Services Normal User                                          
const NewServicesUser = Loadable(lazy(() => import('views/user/ServicesView/NewServicesView')));

// List Services Normal User                                          
const ListServicesUser = Loadable(lazy(() => import('views/user/ServicesView/ListServicesView')));


// Proveedores
// Grupo Proveedores
const ListGrupoProveedoresUser = Loadable(lazy(() => import('views/user/ProveedoresView/GrupoProveedoresView/ListGrupoProveedorView')));
// New Grupo Proveedor User                                          
const NewGrupoProveedorUser = Loadable(lazy(() => import('views/user/ProveedoresView/GrupoProveedoresView/NewGrupoProveedorView')));

// New Proveedores User                                          
const NewProveedoresUser = Loadable(lazy(() => import('views/user/ProveedoresView/ProveedoresView/NewProveedores')));

// List Proveedores
const ListProveedoresUser = Loadable(lazy(() => import('views/user/ProveedoresView/ProveedoresView/ListProveedoresView')));

// New Unidad Medida User
const NewUnidadMedidaUser = Loadable(lazy(() => import('views/user/ProductsView/UnidadMedidaView/NewUnidadMedidaView')));

// List Unidad Medida  User
const ListUnidadMedidaUser = Loadable(lazy(() => import('views/user/ProductsView/UnidadMedidaView/ListUnidadMedidaView')));

// New Prices User
const NewPricesUser = Loadable(lazy(() => import('views/user/ProductsView/PricesView/NewPricesView')));

// List Prices  User
const ListPricesUser = Loadable(lazy(() => import('views/user/ProductsView/PricesView/ListPricesView')));

// New Clients User
const NewClientsUser = Loadable(lazy(() => import('views/clients/NewClientsView')));

// List Clients  User
const ListClientsUser = Loadable(lazy(() => import('views/clients/ListClientsView')));

// New Compuestos-Quimicos User
const NewCompuestosQuimicosUser = Loadable(lazy(() => import('views/user/ProductsView/CompuestosQuimicosView/NewCompuestosQuimicosView')));

// List Compuestos-Quimicos User
const ListCompuestosQuimicosUser = Loadable(lazy(() => import('views/user/ProductsView/CompuestosQuimicosView/ListCompuestosQuimicosView')));

// Modificar Precio
const ModificarPrecioProductoUser = Loadable(lazy(() => import('views/user/ProductsView/ModificarPrecioView')));

// Practica
const PractivaView = Loadable(lazy(() => import('views/practica')));

// Ayuda
const AyudaView = Loadable(lazy(() => import('views/user/ayudaView')));
const AyudaInventarioView = Loadable(lazy(() => import('views/user/ayudaView/ayudaInventarioView')));
const AyudaAprobarProductosView = Loadable(lazy(() => import('views/user/ayudaView/ayudaAprobarProductosView')));
const AyudaAnularComprasView = Loadable(lazy(() => import('views/user/ayudaView/ayudaAnularComprasView')));
const AyudaAnularCierreCajaView = Loadable(lazy(() => import('views/user/ayudaView/ayudaAnularCierreCajaView')));
const AyudaRetencionEmpresaComercialView = Loadable(lazy(() => import('views/user/ayudaView/ayudaRetencionEmpresaComercialView')));
const AyudaAnularSoloRetencionComprasView = Loadable(lazy(() => import('views/user/ayudaView/ayudaAnularSoloRetencionComprasView')));
const AyudaCorregirDatosCompraView = Loadable(lazy(() => import('views/user/ayudaView/ayudaCorregirDatosCompraView')));
const AyudaAnularVentaView = Loadable(lazy(() => import('views/user/ayudaView/ayudaAnularVentaView')));
const AyudaDevolucionesSistemaAnteriorView = Loadable(
    lazy(() => import('views/user/ayudaView/ayudaDevolucionesSistemaAnteriorView'))
);
const AyudaLiquidacionTarjetasView = Loadable(lazy(() => import('views/user/ayudaView/ayudaLiquidacionTarjetasView')));
const AyudaCruceLotesTemporalesView = Loadable(lazy(() => import('views/user/ayudaView/ayudaCruceLotesTemporalesView')));
const AyudaEgresoDirectoView = Loadable(lazy(() => import('views/user/ayudaView/ayudaEgresoDirectoView')));
const AyudaCruceNotasCreditoView = Loadable(lazy(() => import('views/user/ayudaView/ayudaCruceNotasCreditoView')));
const AyudaCierreEjercicioView = Loadable(lazy(() => import('views/user/ayudaView/ayudaCierreEjercicioView')));
const AyudaCierrePeriodosView = Loadable(lazy(() => import('views/user/ayudaView/ayudaCierrePeriodosView')));
const AyudaRolPagosView = Loadable(lazy(() => import('views/user/ayudaView/ayudaRolPagosView')));
const AyudaProduccionView = Loadable(lazy(() => import('views/user/ayudaView/ayudaProduccionView')));

// Create new Forma Pago Personalizado
const NewFormaPagoPersonalizado = Loadable(lazy(() => import('views/administrator/NewPagoPersonalizadoView')));

// List Forma Pago Personalizado
const ListPagoPersonalizadoView = Loadable(lazy(() => import('views/administrator/ListPagoPersonalizadoView')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            breadcrumbs: false,
            element: <DashBoard />
        },        
        {
            path: '/dashboard',
            breadcrumbs: false,
            element: <DashBoard />
        },        
        {
            path: '/user/setting-user',
            element: <SettingUserView />
        },        
        {
            path: '/user/new-user/:id_users',
            element: <NewUserView />
        },
        {
            path: '/user/list-user-admin',
            element: <ListUserView />
        },
        {
            path: '/user/list-user-admin',
            element: <ListUserView />
        },
        {
            path: '/company/new-company/:id_company',
            element: <NewCompanyView />
        },
        {
            path: '/company/list-company-admin',
            element: <ListCompanyView />
        },
        {
            path: '/countable/new-user/:id_users',
            element: <NewUserViewCountable />
        },
        {
            path: '/countable/list-user',
            element: <ListUserViewCountable />
        },
        {
            path: '/countable/new-permission',
            element: <NewPermissionView />
        },
        {
            path: '/countable/list-permission',
            element: <ListPermissionView />
        },
        {
            path: '/countable/edit-permission/:id_permission',
            element: <EditPermissionView />
        },
        {
            path: '/logs/log-system',
            element: <LogSystemView />
        },
        {
            path: '/common/user/edit-profile/:id_users',
            element: <EditProfileView />
        },
        {
            path: '/common/detalle-version',
            element: <DetalleVersionView />
        },
        {
            path: '/superadmin/new-type-company/:id_type_company',
            element: <NewTypeCompanyView />
        },
        {
            path: '/superadmin/list-type-company',
            element: <ListTypeCompanyView />
        },
        {
            path: '/superadmin/new-estados-financieros/:id_estados_financieros',
            element: <NewEstadosFinancierosView />
        },
        {
            path: '/superadmin/list-estados-financieros',
            element: <ListEstadosFinancierosView />
        },
        {
            path: '/superadmin/list-versions',
            element: <ListVersionsView />
        },
        {
            path: '/superadmin/new-version/:id_versions',
            element: <NewVersionView />
        },
        {
            path: '/superadmin/log-version/:id_versions',
            element: <LogVersionView />
        },
        {
            path: '/superadmin/list-reportes-generales',
            element: <ListReportesGeneralesAdminView />
        },
        {
            path: '/superadmin/new-reporte-general/:id_cabeceras_reportes_generales_admin',
            element: <NewReporteGeneralAdminView />
        },
        {
            path: '/superadmin/new-account-class1/:id_account_1',
            element: <NewAccountClass1 />
        },
        {
            path: '/superadmin/list-account-class1',
            element: <ListAccountViewClass1 />
        },
        {
            path: '/superadmin/new-account-class2/:id_account_2',
            element: <NewAccountClass2 />
        },
        {
            path: '/superadmin/list-account-class2',
            element: <ListAccountViewClass2 />
        },
        {
            path: '/superadmin/new-account-class3/:id_account_3',
            element: <NewAccountClass3 />
        },
        {
            path: '/superadmin/list-account-class3',
            element: <ListAccountViewClass3 />
        },
        {
            path: '/superadmin/new-account-class4/:id_account_4',
            element: <NewAccountClass4 />
        },
        {
            path: '/superadmin/list-account-class4',
            element: <ListAccountViewClass4 />
        },
        {
            path: '/superadmin/new-account-class5/:id_account_5',
            element: <NewAccountClass5 />
        },
        {
            path: '/superadmin/list-account-class5',
            element: <ListAccountViewClass5 />
        },
        {
            path: '/user/new-account-class1/:id_account_1',
            element: <NewAccountClass1User />
        },
        {
            path: '/user/list-account-class1',
            element: <ListAccountViewClass1User />
        },
        {
            path: '/user/new-account-class2/:id_account_2',
            element: <NewAccountClass2User />
        },
        {
            path: '/user/list-account-class2',
            element: <ListAccountViewClass2User />
        },
        {
            path: '/user/new-account-class3/:id_account_3',
            element: <NewAccountClass3User />
        },
        {
            path: '/user/list-account-class3',
            element: <ListAccountViewClass3User />
        },
        {
            path: '/user/new-account-class4/:id_account_4',
            element: <NewAccountClass4User />
        },
        {
            path: '/user/list-account-class4',
            element: <ListAccountViewClass4User />
        },
        {
            path: '/user/new-account-class5/:id_account_5',
            element: <NewAccountClass5User />
        },
        {
            path: '/user/list-account-class5',
            element: <ListAccountViewClass5User />
        },
        {
            path: '/user/settings-wizard-company',
            element: <WizardSettingCompanyView />
        },
        {
            path: '/user/list-reportes-administracion',
            element: <ListReportesAdministracionView />
        },
        {
            path: '/user/edit-reporte-administracion/:id_reportes_generales_por_company',
            element: <EditReporteAdministracionView />
        },
        {
            path: '/user/edit-company',
            element: <EditCompanyView />
        },
        {
            path: '/user/list-all-plan-account',
            element: <ListAllAccountView />
        },
        {
            path: '/user/new-line/:id_line',
            element: <NewLineUser />
        },
        {
            path: '/user/list-line',
            element: <ListLineUser />
        },
        {
            path: '/user/new-category/:id_category',
            element: <NewCategoryUser />
        },
        {
            path: '/user/list-category',
            element: <ListCategoryUser />
        },
        {
            path: '/user/new-subcategory/:id_subcategory',
            element: <NewSubcategoryUser />
        },
        {
            path: '/user/list-subcategory',
            element: <ListSubcategoryUser />
        },
        {
            path: '/user/new-groups/:id_groups',
            element: <NewGroupsUser />
        },
        {
            path: '/user/list-groups',
            element: <ListGroupsUser />
        },
        {
            path: '/user/new-tipos_iva/:id_tipos_iva',
            element: <NewTiposIvaUser />
        },
        {
            path: '/user/list-tipos_iva',
            element: <ListTiposIvaUser />
        },
        {
            path: '/user/new-codes-ice/:id_codes_ice',
            element: <NewCodesIceUser />
        },
        {
            path: '/user/list-codes-ice',
            element: <ListCodesIceUser />
        },
        {
            path: '/user/new-codigo-retenciones/:id_codigo_retenciones',
            element: <NewCodigoRetencionesUser />
        },
        {
            path: '/user/list-codigo-retenciones',
            element: <ListCodigoRetencionesUser />
        },
        {
            path: '/user/new-product/:id_products',
            element: <NewProductsUser />
        },
        {
            path: '/user/list-products-view',
            element: <ListProductsUser />
        },
        {
            path: '/user/modificar-precio-view',
            element: <ModificarPrecioProductoUser />
        },
        {
            path: '/user/new-service/:id_products',
            element: <NewServicesUser />
        },
        {
            path: '/user/list-services-view',
            element: <ListServicesUser />
        },
        {
            path: '/user/list-grupo-proveedores-view',
            element: <ListGrupoProveedoresUser />
        },
        {
            path: '/user/new-grupo-proveedor/:id_grupo_proveedores',
            element: <NewGrupoProveedorUser />
        },
        {
            path: '/user/new-proveedores/:id_proveedores',
            element: <NewProveedoresUser />
        },
        {
            path: '/user/list-proveedores-view',
            element: <ListProveedoresUser />
        },
        {
            path: '/user/new-unidad-medida/:id_unidad_medida',
            element: <NewUnidadMedidaUser />
        },
        {
            path: '/user/list-unidad-medida-view',
            element: <ListUnidadMedidaUser />
        },
        {
            path: '/user/new-prices/:id_prices',
            element: <NewPricesUser />
        },
        {
            path: '/user/list-prices-view',
            element: <ListPricesUser />
        },
        {
            path: '/user/new-clients/:id_clients',
            element: <NewClientsUser />
        },
        {
            path: '/user/list-clients-view',
            element: <ListClientsUser />
        },
        {
            path: '/user/new-compuesto-quimico/:id_compuestos_quimicos',
            element: <NewCompuestosQuimicosUser />
        },
        {
            path: '/user/list-compuesto-quimico-view',
            element: <ListCompuestosQuimicosUser />
        },
        {
            path: '/user/practica',
            element: <PractivaView />
        },
                {
            path: '/user/new-pago-personalizado/:id_forma_pago_personalizado',
            element: <NewFormaPagoPersonalizado />
        },
        {
            path: '/user/list-pago-personalizado-view',
            element: <ListPagoPersonalizadoView />
        },
        {
            path: '/user/ayuda-view',
            element: <AyudaView />
        },
        {
            path: '/user/ayuda-inventario-view',
            element: <AyudaInventarioView />
        },
        {
            path: '/user/ayuda-aprobar-productos-view',
            element: <AyudaAprobarProductosView />
        },
        {
            path: '/user/ayuda-anular-compras-view',
            element: <AyudaAnularComprasView />
        },
        {
            path: '/user/ayuda-anular-cierre-caja-view',
            element: <AyudaAnularCierreCajaView />
        },
        {
            path: '/user/ayuda-retencion-empresa-comercial-view',
            element: <AyudaRetencionEmpresaComercialView />
        },
        {
            path: '/user/ayuda-anular-solo-retencion-compras-view',
            element: <AyudaAnularSoloRetencionComprasView />
        },
        {
            path: '/user/ayuda-corregir-datos-compra-view',
            element: <AyudaCorregirDatosCompraView />
        },
        {
            path: '/user/ayuda-anular-venta-view',
            element: <AyudaAnularVentaView />
        },
        {
            path: '/user/ayuda-devoluciones-sistema-anterior-view',
            element: <AyudaDevolucionesSistemaAnteriorView />
        },
        {
            path: '/user/ayuda-liquidacion-tarjetas-view',
            element: <AyudaLiquidacionTarjetasView />
        },
        {
            path: '/user/ayuda-cruce-lotes-temporales-view',
            element: <AyudaCruceLotesTemporalesView />
        },
        {
            path: '/user/ayuda-egreso-directo-view',
            element: <AyudaEgresoDirectoView />
        },
        {
            path: '/user/ayuda-cruce-notas-credito-view',
            element: <AyudaCruceNotasCreditoView />
        },
        {
            path: '/user/ayuda-cierre-ejercicio-view',
            element: <AyudaCierreEjercicioView />
        },
        {
            path: '/user/ayuda-cierre-periodos-view',
            element: <AyudaCierrePeriodosView />
        },
        {
            path: '/user/ayuda-rol-pagos-view',
            element: <AyudaRolPagosView />
        },
        {
            path: '/user/ayuda-produccion-view',
            element: <AyudaProduccionView />
        },
    ]
};

export default MainRoutes;
